// 全站側邊選單
'use client';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { popState, setShowMenu } from '@/slices/popSlice';
import { useTranslation } from 'react-i18next';
import anaClient from '@/common/apiClient/anaClient';

import MenuLogo from './menu/MenuLogo'; // 側邊選單 logo
import MenuBannerSwiper from '../swiper/MenuBannerSwiper'; // 活動 banner
import MenuPage from './menu/MenuPage'; // 頁面連結
import MenuSocial from './menu/MenuSocial'; // 選單社群連結
import FooterToggleLanguage from './footer/FooterToggleLanguage'; // 語言切換
import MenuKeyword from './menu/MenuKeyword'; // 熱門關鍵字
import MenuPostButton from './menu/MenuPostButton'; // 發文按鈕
import MenuListContent from './menu/MenuListContent'; // 選單其他連結
import MenuUserLink from './menu/MenuUserLink'; // 用戶相關連結
import MenuTheme from './menu/MenuTheme'; // 深淺切換
import LogoutButton from './user/LogoutButton'; // 登出按鈕
import UserToggleAdultButton from './modal/user/UserToggleAdultButton'; // 成人模式切換按鈕

const AsideMenu = ({ bannerList = [], locale }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { showMenu } = useSelector(popState);

    // 熱門關鍵字
    const [keywords, setKeywords] = useState([]);

    // 關閉彈窗
    const onClose = () => dispatch(setShowMenu(true));

    // 桌機版關閉
    const onCloseMenu = () => {
        if (window?.innerWidth < 1024) {
            dispatch(setShowMenu(true));
        }
    };

    // 取得關鍵字
    const getSearchOption = async () => {
        try {
            const { searchOption } = await anaClient.getSearchKeywords(locale);
            if (searchOption && searchOption.length) setKeywords(searchOption);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getSearchOption();
    }, []);

    return (
        <>
            <aside
                className={`trans sticky h-screen top-0 flex-shrink-0 border-black1 border-r-1 pt-[14px] pb-[20px]
                bg-white space-y-[30px] noScrollY ${
                    showMenu
                        ? 'w-[200px] px-[13px] ulg:left-[-271px]'
                        : 'w-[60px] px-[5px] ulg:left-0'
                } ulg:top-0 ulg:!w-[270px]
                ulg:!px-[24px] ulg:!py-[27px] ulg:fixed ulg:h-screen ulg:z-[23]`}
            >
                {/* logo */}
                <MenuLogo showMenu={showMenu} onClose={onClose} />

                {/* 手機版發文按鈕 */}
                <MenuPostButton t={t} />

                {/* 頁面連結 */}
                <MenuPage t={t} showMenu={showMenu} onClose={onCloseMenu} />

                {/* 用戶相關連結 */}
                <MenuUserLink />

                {/* 手機版成人模式切換 */}
                <div className="hidden ulg:block">
                    <UserToggleAdultButton location="menu" />
                </div>

                {/* 活動 banner */}
                {bannerList?.length > 0 && (
                    <MenuBannerSwiper showMenu={showMenu} bannerList={bannerList} />
                )}

                {/* 深淺切換 */}
                <MenuTheme />

                {/* 熱門關鍵字 */}
                {keywords?.length > 0 && showMenu && (
                    <MenuKeyword t={t} keywords={keywords} locale={locale} />
                )}

                {/* 選單其他連結 */}
                <MenuListContent t={t} />

                {/* 分隔線 */}
                {showMenu && (
                    <hr className="w-full border-t-1 ulg:hidden border-black2 border-opacity-[.4]" />
                )}

                {/* 選單社群連結 */}
                <MenuSocial t={t} showMenu={showMenu} />

                {/* 登出按鈕 */}
                <div className="hidden ulg:block">
                    <LogoutButton t={t} />
                </div>

                {/* 語言切換 */}
                <FooterToggleLanguage position="menu" />
            </aside>

            {/* 手機版 關閉用 */}
            <div
                onClick={() => dispatch(setShowMenu(true))}
                className={`hidden fixed top-0 left-0 w-screen h-screen z-[22] bg-[rgba(0,0,0,.2)] ${
                    showMenu ? '' : 'ulg:block'
                }`}
            />
        </>
    );
};

export default AsideMenu;
